/* ==========================================================
   TAC DRAFTS
   Tus Álbum Cool
   Shopify Customizer ↔ Cloudflare Worker ↔ D1
   ========================================================== */

const TAC_DRAFT_PRODUCT_HANDLE =
  String(
    window
      .TAC_SHOPIFY_CONFIG
      ?.productHandle ||
    ""
  )
    .trim()
    .toLowerCase();




/* ==========================================================
   TAC DRAFT CLIENT
   Shopify Customizer ↔ Cloudflare Worker ↔ D1
   v1
   ========================================================== */

const TAC_DRAFT_API =
  "https://tac-files-api.uralbum-cool.workers.dev";


const TAC_DRAFT_STORAGE_KEY =
  "tac:draft-session:v1:" +
  String(TAC_DRAFT_PRODUCT_HANDLE || "")
    .trim()
    .toLowerCase();


window.tacDraftClient =
  window.tacDraftClient || {

    session:
      null,

    initPromise:
      null,

    config:
      null,

    turnstileWidgetId:
      null,


    /* =========================
       AUTOSAVE
       ========================= */

    currentStepKey:
      "portada",

    saveState:
      "clean",

    saveTimer:
      null,

    retryTimer:
      null,

    savePromise:
      null,

    saveQueued:
      false,

    lastSavedFingerprint:
      null,

    lastError:
      null,


    /*
      Configuración que sabemos
      que existe actualmente en D1.
    */

    serverConfiguration:
      {},


    /*
      IMPORTANTE:

      Si recuperamos un draft que YA
      contiene configuración, no debemos
      sobrescribirla con una UI todavía
      vacía antes de 8.4D.

      Por eso este switch puede bloquear
      temporalmente autosave.
    */

    hydrationReady:
      true,

    wasRestored:
      false

  };
  


/* ==========================================================
   STORAGE
   ========================================================== */

function tacDraftReadStoredSession() {

  try {

    const raw =
      localStorage.getItem(
        TAC_DRAFT_STORAGE_KEY
      );


    if (!raw) {
      return null;
    }


    const parsed =
      JSON.parse(raw);


    if (
      !parsed?.id ||
      !parsed?.token
    ) {

      localStorage.removeItem(
        TAC_DRAFT_STORAGE_KEY
      );

      return null;

    }


    return parsed;


  } catch (error) {

    console.warn(
      "[TAC Draft] No se pudo leer localStorage",
      error
    );


    return null;

  }

}


function tacDraftStoreSession(
  session
) {

  try {

    localStorage.setItem(
      TAC_DRAFT_STORAGE_KEY,
      JSON.stringify({

        id:
          session.id,

        token:
          session.token,

        revision:
          Number(
            session.revision || 1
          ),

        expires_at:
          session.expires_at || null,

        product_handle:
          TAC_DRAFT_PRODUCT_HANDLE

      })
    );


  } catch (error) {

    console.warn(
      "[TAC Draft] No se pudo guardar localStorage",
      error
    );

  }

}


function tacDraftClearSession() {

  window.tacDraftClient.session =
    null;


  try {

    localStorage.removeItem(
      TAC_DRAFT_STORAGE_KEY
    );

  } catch (error) {}

}


/* ==========================================================
   API CONFIG
   ========================================================== */

async function tacDraftGetConfig() {

  if (
    window.tacDraftClient.config
  ) {

    return window
      .tacDraftClient
      .config;

  }


  const response =
    await fetch(
      TAC_DRAFT_API +
      "/v1/config",
      {
        method:
          "GET",

        headers: {
          Accept:
            "application/json"
        }
      }
    );


  if (!response.ok) {

    throw new Error(
      "draft_config_" +
      response.status
    );

  }


  const config =
    await response.json();


  if (!config?.ok) {

    throw new Error(
      "draft_config_invalid"
    );

  }


  window.tacDraftClient.config =
    config;


  return config;

}


/* ==========================================================
   TURNSTILE LOADER
   ========================================================== */

async function tacDraftLoadTurnstile() {

  if (
    window.turnstile
  ) {

    return;

  }


  const existing =
    document.querySelector(
      'script[src*="challenges.cloudflare.com/turnstile"]'
    );


  if (!existing) {

    const script =
      document.createElement(
        "script"
      );


    script.src =
      "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";


    script.async =
      true;

    script.defer =
      true;


    document.head.appendChild(
      script
    );

  }


  const startedAt =
    Date.now();


  while (
    !window.turnstile &&
    Date.now() - startedAt <
      10000
  ) {

    await new Promise(
      resolve =>
        setTimeout(
          resolve,
          100
        )
    );

  }


  if (
    !window.turnstile
  ) {

    throw new Error(
      "turnstile_load_failed"
    );

  }

}


/* ==========================================================
   TURNSTILE TOKEN
   ========================================================== */

async function tacDraftGetTurnstileToken() {

  const config =
    await tacDraftGetConfig();


  await tacDraftLoadTurnstile();


  let container =
    document.getElementById(
      "tac-draft-turnstile"
    );


  if (!container) {

    container =
      document.createElement(
        "div"
      );


    container.id =
      "tac-draft-turnstile";


    /*
      Normalmente no se verá.

      Si Cloudflare necesita interacción,
      lo colocamos visible encima del customizer.
    */

    Object.assign(
      container.style,
      {

        position:
          "fixed",

        left:
          "50%",

        bottom:
          "90px",

        transform:
          "translateX(-50%)",

        zIndex:
          "2147483647"

      }
    );


    document.body.appendChild(
      container
    );

  }


  container.innerHTML =
    "";


  return new Promise(
    (
      resolve,
      reject
    ) => {

      let settled =
        false;


      const finish =
        (
          type,
          value
        ) => {

          if (settled) {
            return;
          }


          settled =
            true;


          try {

            if (
              window
                .tacDraftClient
                .turnstileWidgetId !==
                null
            ) {

              window.turnstile.remove(
                window
                  .tacDraftClient
                  .turnstileWidgetId
              );

            }

          } catch (error) {}


          window
            .tacDraftClient
            .turnstileWidgetId =
              null;


          container.innerHTML =
            "";


          if (
            type === "resolve"
          ) {

            resolve(value);

          } else {

            reject(value);

          }

        };


      const timer =
        setTimeout(
          () => {

            finish(
              "reject",
              new Error(
                "turnstile_timeout"
              )
            );

          },
          45000
        );


      window
        .tacDraftClient
        .turnstileWidgetId =
          window.turnstile.render(
            container,
            {

              sitekey:
                config
                  .turnstile
                  .site_key,

              action:
                config
                  .turnstile
                  .action,

              appearance:
                "interaction-only",

              theme:
                "light",


              callback:
                token => {

                  clearTimeout(
                    timer
                  );


                  finish(
                    "resolve",
                    token
                  );

                },


              "error-callback":
                code => {

                  clearTimeout(
                    timer
                  );


                  finish(
                    "reject",
                    new Error(
                      "turnstile_" +
                      code
                    )
                  );

                }

            }
          );

    }
  );

}


/* ==========================================================
   RECUPERAR UN DRAFT EXISTENTE
   ========================================================== */

async function tacDraftRestoreStoredSession() {

  const stored =
    tacDraftReadStoredSession();


  if (!stored) {

    return null;

  }


  try {

    const response =
      await fetch(
        TAC_DRAFT_API +
        "/v1/drafts/" +
        encodeURIComponent(
          stored.id
        ),
        {

          method:
            "GET",

          headers: {

            Authorization:
              "Bearer " +
              stored.token,

            Accept:
              "application/json"

          }

        }
      );


    /*
      Draft inválido, expirado,
      borrado o token incorrecto.
    */

    if (
      response.status === 404 ||
      response.status === 410
    ) {

      tacDraftClearSession();

      return null;

    }


    if (!response.ok) {

      throw new Error(
        "draft_restore_" +
        response.status
      );

    }


    const result =
      await response.json();


    if (
      !result?.ok ||
      !result?.draft?.id
    ) {

      tacDraftClearSession();

      return null;

    }


    const session = {

      id:
        result.draft.id,

      token:
        stored.token,

      revision:
        Number(
          result.draft.revision ||
          stored.revision ||
          1
        ),

      expires_at:
        result.draft.expires_at ||
        stored.expires_at ||
        null

    };


    window
      .tacDraftClient
      .session =
        session;


    tacDraftStoreSession(
      session
    );

const existingConfiguration =
  (
    result.draft.configuration &&
    typeof result.draft.configuration ===
      "object" &&
    !Array.isArray(
      result.draft.configuration
    )
  )
    ? result.draft.configuration
    : {};


window
  .tacDraftClient
  .serverConfiguration =
    existingConfiguration;


window
  .tacDraftClient
  .currentStepKey =
    result.draft.current_step_key ||
    "portada";


window
  .tacDraftClient
  .wasRestored =
    true;


/*
  Si este draft todavía está vacío,
  podemos empezar autosave inmediatamente.

  Si YA contiene diseño, esperamos a
  8.4D para hidratar la UI antes de escribir.
*/

window
  .tacDraftClient
  .hydrationReady =
    Object.keys(
      existingConfiguration
    ).length === 0;


if (
  !window
    .tacDraftClient
    .hydrationReady
) {

  console.log(
    "[TAC Draft] 🛡️ Draft con diseño existente. Autosave pausado hasta restaurar la UI."
  );

}



    console.log(
      "[TAC Draft] ♻️ Recuperado:",
      session.id
    );


    return session;


  } catch (
    error
  ) {

    /*
      IMPORTANTE:

      Si hay un simple problema
      temporal de internet NO borramos
      la sesión existente.
    */

    console.warn(
      "[TAC Draft] No se pudo comprobar el draft guardado",
      error
    );


    throw error;

  }

}


/* ==========================================================
   CREAR DRAFT NUEVO
   ========================================================== */

async function tacDraftCreate() {

  const turnstileToken =
    await tacDraftGetTurnstileToken();


  const response =
    await fetch(
      TAC_DRAFT_API +
      "/v1/drafts",
      {

        method:
          "POST",

        headers: {

          "Content-Type":
            "application/json",

          Accept:
            "application/json"

        },

        body:
          JSON.stringify({

            turnstile_token:
              turnstileToken,

            product_handle:
              TAC_DRAFT_PRODUCT_HANDLE,

            current_step_key:
              "portada",

            configuration: {},

            locale:
              String(
                window.tacLang ||
                "es"
              ),

            currency:
              String(
                window
                  .TAC_ADDONS
                  ?.currency ||
                "MXN"
              ),

            country_code:
  window
    .TAC_SHOPIFY_CONFIG
    ?.countryCode ||
  "MX"

          })

      }
    );


  const result =
    await response.json();


  if (
    !response.ok ||
    !result?.ok ||
    !result?.draft?.id ||
    !result?.draft?.token
  ) {

    throw new Error(
      result?.error ||
      (
        "draft_create_" +
        response.status
      )
    );

  }


  const session = {

    id:
      result.draft.id,

    token:
      result.draft.token,

    revision:
      Number(
        result.draft.revision ||
        1
      ),

    expires_at:
      result.draft.expires_at ||
      null

  };

  window
  .tacDraftClient
  .serverConfiguration =
    {};


window
  .tacDraftClient
  .currentStepKey =
    result.draft.current_step_key ||
    "portada";


window
  .tacDraftClient
  .wasRestored =
    false;


window
  .tacDraftClient
  .hydrationReady =
    true;

  window
    .tacDraftClient
    .session =
      session;


  tacDraftStoreSession(
    session
  );


  console.log(
    "[TAC Draft] ✨ Creado:",
    session.id
  );


  return session;

}


/* ==========================================================
   ENSURE SESSION

   Esta es la única función que el customizer
   necesita llamar.
   ========================================================== */

async function tacEnsureDraftSession() {

  if (
    window
      .tacDraftClient
      .session
      ?.id
  ) {

    return window
      .tacDraftClient
      .session;

  }


  /*
    Evita dos POST simultáneos si el usuario
    hace doble click o algún evento se dispara
    dos veces.
  */

  if (
    window
      .tacDraftClient
      .initPromise
  ) {

    return window
      .tacDraftClient
      .initPromise;

  }


  window
    .tacDraftClient
    .initPromise =
      (
        async () => {

          const restored =
            await tacDraftRestoreStoredSession();


          if (restored) {

            return restored;

          }


          return await tacDraftCreate();

        }
      )();


  try {

    return await window
      .tacDraftClient
      .initPromise;


  } finally {

    window
      .tacDraftClient
      .initPromise =
        null;

  }

}

/* ==========================================================
   TAC DRAFT AUTOSAVE
   Customizer → Worker → D1
   ========================================================== */


/* ----------------------------------------------------------
   CLONE JSON SEGURO
   ---------------------------------------------------------- */

function tacDraftJsonClone(
  value,
  fallback
) {

  try {

    return JSON.parse(
      JSON.stringify(
        value
      )
    );

  } catch (error) {

    return fallback;

  }

}


/* ----------------------------------------------------------
   NORMALIZAR ARRAYS DE TEXTO
   ---------------------------------------------------------- */

function tacDraftStringArray(
  value
) {

  return Array.isArray(value)
    ? value.map(
        item =>
          String(
            item ?? ""
          )
      )
    : [];

}


/* ----------------------------------------------------------
   CONSTRUIR CONFIGURACIÓN PERSISTENTE

   MUY IMPORTANTE:
   aquí NO entran:
   - File
   - Blob
   - blob:
   - Object URLs

   Las fotografías reales llegan en 8.4C.
   ---------------------------------------------------------- */

function tacDraftBuildConfiguration() {

  const data =
    window.tacCustomizer
      ?.data || {};


  const activeSteps =
    Array.isArray(
      window.tacCustomizer
        ?.activeSteps
    )
      ? window
          .tacCustomizer
          .activeSteps
      : [];


  /*
    Partimos de lo que ya conoce el
    servidor para no destruir campos
    futuros que todavía no manejemos.
  */

  const base =
    tacDraftJsonClone(
      window
        .tacDraftClient
        ?.serverConfiguration ||
        {},
      {}
    );


  const pricing =
    data.pricing || {};


  const configuration = {

    ...base,


    schema_version:
      1,


    product_handle:
      TAC_DRAFT_PRODUCT_HANDLE,


    data: {

      portada: {

  diseno:
    data.portada
      ?.diseno ||
    null,


  frase:
    String(
      data.portada
        ?.frase || ""
    ),


  nombres:
    String(
      data.portada
        ?.nombres || ""
    ),


  fecha:
    String(
      data.portada
        ?.fecha || ""
    ),


  /*
    Referencia lógica a la foto.

    NO guardamos File,
    NO guardamos blob:,
    NO guardamos bytes en D1.
  */

  foto:
    data.portada
      ?.fotoRemote
      ?.id
      ? {

          file_id:
            data.portada
              .fotoRemote
              .id,

          category:
            "cover",

          position:
            1,

          status:
            data.portada
              .fotoRemote
              .status,

          object_key:
            data.portada
              .fotoRemote
              .object_key ||
            null,

          stored_size_bytes:
            data.portada
              .fotoRemote
              .stored_size_bytes ||
            null,

          etag:
            data.portada
              .fotoRemote
              .etag ||
            null

        }
      : (
          base
            ?.data
            ?.portada
            ?.foto ||
          null
        )

},

fotos_estampas: {

  files:
    Array.isArray(
      data.fotos_estampas
        ?.remotes
    )
      ? data
          .fotos_estampas
          .remotes
          .map(
            (
              remote,
              index
            ) => {

              if (
                !remote?.id
              ) {

                return null;

              }


              return {

                file_id:
                  remote.id,

                category:
                  "stamps",

                position:
                  index + 1,

                status:
                  remote.status,

                object_key:
                  remote.object_key ||
                  null,

                stored_size_bytes:
                  remote
                    .stored_size_bytes ??
                  null,

                etag:
                  remote.etag ||
                  null

              };

            }
          )
      : (
          base
            ?.data
            ?.fotos_estampas
            ?.files ||
          []
        )

},

      dedicatoria: {

        deParteDe:
          String(
            data.dedicatoria
              ?.deParteDe || ""
          )

      },


      texto_final: {

        texto:
          String(
            data.texto_final
              ?.texto || ""
          )

      },


      spotify_playlist: {

        link:
          String(
            data.spotify_playlist
              ?.link || ""
          )

      },


      peliculas: {

        items:
          tacDraftStringArray(
            data.peliculas
              ?.items
          )

      },


      sopa_letras: {

        items:
          tacDraftStringArray(
            data.sopa_letras
              ?.items
          )

      },


      fecha_especial: {

        value:
          String(
            data.fecha_especial
              ?.value || ""
          )

      },


      spotify_codigos: {

        canciones:
          tacDraftStringArray(
            data.spotify_codigos
              ?.canciones
          )

      },


      /*
        El texto asociado a fotos SÍ
        puede persistirse desde ahora.

        Los archivos todavía no.
      */

      fotos_con_texto: {

        textos:
          tacDraftStringArray(
            data.fotos_con_texto
              ?.textos
          )

      }

    },


    pricing: {

      fotos_qty:
        pricing.fotos_qty ??
        null,

      fotos_addon_variant_id:
        pricing
          .fotos_addon_variant_id ??
        null,

      extras:
        tacDraftJsonClone(
          pricing.extras || {},
          {}
        )

    },


    /*
      Esto nos permitirá reconstruir
      después el flujo flexible y los
      AddOns elegidos.
    */

    flow: {

      active_steps:
        tacDraftJsonClone(
          activeSteps,
          []
        )

    }

  };


  return configuration;

}


/* ----------------------------------------------------------
   ESTADO DEL AUTOSAVE
   ---------------------------------------------------------- */

function tacDraftSetSaveState(
  state,
  error = null
) {

  const client =
    window.tacDraftClient;


  client.saveState =
    state;


  client.lastError =
    error;


  /*
    Después convertiremos esto
    en UI aesthetic.

    Por ahora sólo lo exponemos
    internamente.
  */

}


/* ----------------------------------------------------------
   PROGRAMAR AUTOSAVE

   Debounce: 750ms.
   ---------------------------------------------------------- */

function tacDraftScheduleSave(
  {
    immediate = false,
    reason = "change"
  } = {}
) {

  const client =
    window.tacDraftClient;


  if (!client) {
    return;
  }


  /*
    Seguridad temporal hasta 8.4D.

    Nunca escribimos sobre un draft
    restaurado antes de hidratar la UI.
  */

  if (
    client.hydrationReady !==
      true
  ) {

    return;

  }


  tacDraftSetSaveState(
    "dirty"
  );


  clearTimeout(
    client.saveTimer
  );


  client.saveTimer =
    setTimeout(
      () => {

        tacDraftFlushSave(
          reason
        );

      },
      immediate
        ? 0
        : 750
    );

}


/* ----------------------------------------------------------
   EJECUTAR AUTOSAVE
   ---------------------------------------------------------- */

async function tacDraftFlushSave(
  reason = "manual"
) {

  const client =
    window.tacDraftClient;


  if (!client) {
    return false;
  }


  if (
    client.hydrationReady !==
      true
  ) {

    return false;

  }


  /*
    Si ya hay un PUT trabajando,
    NO lanzamos otro simultáneo.
  */

  if (
    client.savePromise
  ) {

    client.saveQueued =
      true;


    return client.savePromise;

  }


  client.saveQueued =
    false;


  client.savePromise =
    (
      async () => {

        try {

          const session =
            await tacEnsureDraftSession();


          if (
            !session?.id ||
            !session?.token
          ) {

            throw new Error(
              "draft_session_missing"
            );

          }


          const configuration =
            tacDraftBuildConfiguration();


          const currentStepKey =
            client.currentStepKey ||
            "portada";


          /*
            Fingerprint:

            si nada cambió realmente,
            NO hacemos un PUT inútil.
          */

          const fingerprint =
            JSON.stringify({

              current_step_key:
                currentStepKey,

              configuration

            });


          if (
            fingerprint ===
              client
                .lastSavedFingerprint
          ) {

            tacDraftSetSaveState(
              "saved"
            );


            return true;

          }


          tacDraftSetSaveState(
            "saving"
          );


          const response =
            await fetch(
              TAC_DRAFT_API +
              "/v1/drafts/" +
              encodeURIComponent(
                session.id
              ),
              {

                method:
                  "PUT",

                headers: {

                  Authorization:
                    "Bearer " +
                    session.token,

                  "Content-Type":
                    "application/json",

                  Accept:
                    "application/json"

                },

                body:
                  JSON.stringify({

                    revision:
                      Number(
                        session.revision
                      ),

                    current_step_key:
                      currentStepKey,

                    configuration

                  })

              }
            );


          let result = {};


          try {

            result =
              await response.json();

          } catch (error) {}


          /* ===============================================
             REVISION CONFLICT

             No sobrescribimos silenciosamente
             otro navegador/pestaña.
             =============================================== */

          if (
            response.status === 409 &&
            result?.error ===
              "revision_conflict"
          ) {

            tacDraftSetSaveState(
              "conflict",
              result
            );


            console.warn(
              "[TAC Draft] ⚠️ Conflicto de revisión. Autosave detenido para proteger el diseño.",
              result
            );


            return false;

          }


          if (
            !response.ok ||
            !result?.ok
          ) {

            throw new Error(
              result?.error ||
              (
                "draft_save_" +
                response.status
              )
            );

          }


          /* ===============================================
             ÉXITO
             =============================================== */

          session.revision =
            Number(
              result.draft
                ?.revision ||
              session.revision
            );


          session.expires_at =
            result.draft
              ?.expires_at ||
            session.expires_at;


          client
            .serverConfiguration =
              configuration;


          client
            .lastSavedFingerprint =
              fingerprint;


          tacDraftStoreSession(
            session
          );


          tacDraftSetSaveState(
            "saved"
          );


          console.log(
            "[TAC Draft] 💾 Guardado · rev",
            session.revision,
            "·",
            currentStepKey,
            "·",
            reason
          );


          return true;


        } catch (
          error
        ) {

          tacDraftSetSaveState(
            "error",
            error
          );


          console.error(
            "[TAC Draft] ❌ Autosave:",
            error
          );


          /*
            Error temporal:
            dejamos una sola recuperación
            diferida, no un loop agresivo.
          */

          clearTimeout(
            client.retryTimer
          );


          client.retryTimer =
            setTimeout(
              () => {

                if (
                  navigator.onLine &&
                  client.saveState ===
                    "error"
                ) {

                  tacDraftScheduleSave({
                    immediate:
                      true,

                    reason:
                      "retry"
                  });

                }

              },
              3000
            );


          return false;

        }

      }
    )();


  try {

    return await client
      .savePromise;


  } finally {

    client.savePromise =
      null;


    /*
      Si el cliente siguió escribiendo
      mientras guardábamos, hacemos
      inmediatamente el siguiente snapshot.
    */

    if (
      client.saveQueued
    ) {

      client.saveQueued =
        false;


      tacDraftScheduleSave({
        immediate:
          true,

        reason:
          "queued"
      });

    }

  }

}


/* ----------------------------------------------------------
   DETECTAR CAMBIOS DEL CUSTOMIZER

   Una sola capa global;
   no necesitamos editar 20 inputs uno a uno.
   ---------------------------------------------------------- */

function tacDraftBindAutosaveEvents() {

  if (
    window
      .TAC_DRAFT_AUTOSAVE_BOUND
  ) {

    return;

  }


  window
    .TAC_DRAFT_AUTOSAVE_BOUND =
      true;


  const belongsToCustomizer =
    target => {

      return (
        target instanceof Element &&
        !!target.closest(
          "#customizer-hub"
        )
      );

    };


  document.addEventListener(
    "input",
    event => {

      if (
        !belongsToCustomizer(
          event.target
        )
      ) {

        return;

      }


      tacDraftScheduleSave({
        reason:
          "input"
      });

    },
    true
  );


  document.addEventListener(
    "change",
    event => {

      if (
        !belongsToCustomizer(
          event.target
        )
      ) {

        return;

      }


      tacDraftScheduleSave({
        reason:
          "change"
      });

    },
    true
  );


  /*
    Portadas, AddOns, cantidad de fotos,
    botones YES/NO, navegación, etc.

    El setTimeout deja que primero
    se actualice tacCustomizer.data.
  */

  document.addEventListener(
    "click",
    event => {

      if (
        !belongsToCustomizer(
          event.target
        )
      ) {

        return;

      }


      setTimeout(
        () => {

          tacDraftScheduleSave({
            reason:
              "click"
          });

        },
        0
      );

    }
  );


  /*
    Si vuelve Internet,
    reintentamos cambios pendientes.
  */

  window.addEventListener(
    "online",
    () => {

      const client =
        window.tacDraftClient;


      if (
        client?.saveState ===
          "dirty" ||
        client?.saveState ===
          "error"
      ) {

        tacDraftScheduleSave({
          immediate:
            true,

          reason:
            "online"
        });

      }

    }
  );

}

/* ==========================================================
   TAC FILES CLIENT
   Draft ↔ R2
   ========================================================== */


/* ----------------------------------------------------------
   LISTAR ARCHIVOS DEL DRAFT
   ---------------------------------------------------------- */

async function tacDraftListFiles(
  session
) {

  const response =
    await fetch(
      TAC_DRAFT_API +
      "/v1/drafts/" +
      encodeURIComponent(
        session.id
      ) +
      "/files",
      {

        headers: {

          Authorization:
            "Bearer " +
            session.token,

          Accept:
            "application/json"

        }

      }
    );


  const result =
    await response.json();


  if (
    !response.ok ||
    !result?.ok
  ) {

    throw new Error(
      result?.error ||
      (
        "files_list_" +
        response.status
      )
    );

  }


  return Array.isArray(
    result.files
  )
    ? result.files
    : [];

}


/* ----------------------------------------------------------
   BORRAR RESERVA / ARCHIVO
   ---------------------------------------------------------- */

async function tacDraftDeleteFile(
  session,
  fileId
) {

  const response =
    await fetch(
      TAC_DRAFT_API +
      "/v1/drafts/" +
      encodeURIComponent(
        session.id
      ) +
      "/files/" +
      encodeURIComponent(
        fileId
      ),
      {

        method:
          "DELETE",

        headers: {

          Authorization:
            "Bearer " +
            session.token,

          Accept:
            "application/json"

        }

      }
    );


  const result =
    await response.json();


  if (
    !response.ok ||
    !result?.ok
  ) {

    throw new Error(
      result?.error ||
      (
        "file_delete_" +
        response.status
      )
    );

  }


  return result;

}


/* ----------------------------------------------------------
   NORMALIZAR METADATA REMOTA
   ---------------------------------------------------------- */

function tacDraftNormalizeRemoteFile(
  file,
  originalName = ""
) {

  return {

    id:
      file.id,

    file_id:
      file.id,

    category:
      file.category,

    position:
      Number(
        file.position
      ),

    status:
      file.status,

    object_key:
      file.object_key ||
      null,

    stored_size_bytes:
      file.stored_size_bytes ??
      null,

    etag:
      file.etag ||
      null,

    original_name:
      file.original_name ||
      originalName ||
      ""

  };

}


/* ----------------------------------------------------------
   PRIMER UPLOAD
   PRESIGN → PUT → COMPLETE
   ---------------------------------------------------------- */

async function tacDraftUploadFreshFile(
  session,
  file,
  category,
  position
) {

  /* =============================
     PRESIGN
     ============================= */

  const presignResponse =
    await fetch(
      TAC_DRAFT_API +
      "/v1/drafts/" +
      encodeURIComponent(
        session.id
      ) +
      "/files/presign",
      {

        method:
          "POST",

        headers: {

          Authorization:
            "Bearer " +
            session.token,

          "Content-Type":
            "application/json",

          Accept:
            "application/json"

        },

        body:
          JSON.stringify({

            category:
              category,

            position:
              position,

            name:
              file.name,

            type:
              file.type,

            size:
              file.size

          })

      }
    );


  const presign =
    await presignResponse.json();


  if (
    !presignResponse.ok ||
    !presign?.ok
  ) {

    throw new Error(
      presign?.error ||
      (
        "file_presign_" +
        presignResponse.status
      )
    );

  }


  /* =============================
     PUT DIRECTO A R2
     ============================= */

  const putResponse =
    await fetch(
      presign.upload.url,
      {

        method:
          presign.upload.method,

        headers:
          presign.upload.headers,

        body:
          file

      }
    );


  if (!putResponse.ok) {

    throw new Error(
      "file_put_" +
      putResponse.status
    );

  }


  /* =============================
     COMPLETE / VERIFY
     ============================= */

  const completeResponse =
    await fetch(
      TAC_DRAFT_API +
      "/v1/drafts/" +
      encodeURIComponent(
        session.id
      ) +
      "/files/" +
      encodeURIComponent(
        presign.file.id
      ) +
      "/complete",
      {

        method:
          "POST",

        headers: {

          Authorization:
            "Bearer " +
            session.token,

          Accept:
            "application/json"

        }

      }
    );


  const complete =
    await completeResponse.json();


  if (
    !completeResponse.ok ||
    !complete?.ok ||
    complete.file
      ?.status !==
      "verified"
  ) {

    throw new Error(
      complete?.error ||
      (
        "file_complete_" +
        completeResponse.status
      )
    );

  }


  return complete.file;

}


/* ----------------------------------------------------------
   REEMPLAZAR ARCHIVO EXISTENTE

   El original permanece seguro
   hasta que el nuevo queda verified.
   ---------------------------------------------------------- */

async function tacDraftReplaceFile(
  session,
  currentFile,
  newFile
) {

  /* =============================
     REPLACEMENT PRESIGN
     ============================= */

  const presignResponse =
    await fetch(
      TAC_DRAFT_API +
      "/v1/drafts/" +
      encodeURIComponent(
        session.id
      ) +
      "/files/" +
      encodeURIComponent(
        currentFile.id
      ) +
      "/replacement/presign",
      {

        method:
          "POST",

        headers: {

          Authorization:
            "Bearer " +
            session.token,

          "Content-Type":
            "application/json",

          Accept:
            "application/json"

        },

        body:
          JSON.stringify({

            name:
              newFile.name,

            type:
              newFile.type,

            size:
              newFile.size

          })

      }
    );


  const presign =
    await presignResponse.json();


  if (
    !presignResponse.ok ||
    !presign?.ok
  ) {

    throw new Error(
      presign?.error ||
      (
        "replacement_presign_" +
        presignResponse.status
      )
    );

  }


  /* =============================
     PUT CANDIDATA
     ============================= */

  const putResponse =
    await fetch(
      presign.upload.url,
      {

        method:
          presign.upload.method,

        headers:
          presign.upload.headers,

        body:
          newFile

      }
    );


  if (!putResponse.ok) {

    throw new Error(
      "replacement_put_" +
      putResponse.status
    );

  }


  /* =============================
     SWAP SEGURO
     ============================= */

  const completeResponse =
    await fetch(
      TAC_DRAFT_API +
      "/v1/drafts/" +
      encodeURIComponent(
        session.id
      ) +
      "/files/" +
      encodeURIComponent(
        currentFile.id
      ) +
      "/replacement/complete",
      {

        method:
          "POST",

        headers: {

          Authorization:
            "Bearer " +
            session.token,

          Accept:
            "application/json"

        }

      }
    );


  const complete =
    await completeResponse.json();


  if (
    !completeResponse.ok ||
    !complete?.ok ||
    complete.file
      ?.status !==
      "verified"
  ) {

    throw new Error(
      complete?.error ||
      (
        "replacement_complete_" +
        completeResponse.status
      )
    );

  }


  return complete.file;

}


/* ----------------------------------------------------------
   PORTADA

   category = cover
   position = 1
   ---------------------------------------------------------- */

async function tacDraftUploadPortadaPhoto(
  file
) {

  if (
    !(file instanceof File)
  ) {

    throw new Error(
      "invalid_cover_file"
    );

  }


  const session =
    await tacEnsureDraftSession();


  const files =
    await tacDraftListFiles(
      session
    );


  const currentFile =
    files.find(
      item =>
        item.category ===
          "cover" &&
        Number(
          item.position
        ) === 1
    );


  let savedFile;


  /*
    CASO A:
    Ya existe portada oficial.

    → replacement seguro
  */

  if (
    currentFile?.id &&
    currentFile.status ===
      "verified"
  ) {

    console.log(
      "[TAC Files] 🔄 Reemplazando portada..."
    );


    savedFile =
      await tacDraftReplaceFile(
        session,
        currentFile,
        file
      );

  }


  /*
    CASO B:
    Existe una reserva vieja
    incompleta.

    La retiramos antes de crear
    el slot otra vez.
  */

  else {

    if (
      currentFile?.id
    ) {

      console.log(
        "[TAC Files] 🧹 Limpiando reserva incompleta de portada..."
      );


      await tacDraftDeleteFile(
        session,
        currentFile.id
      );

    }


    console.log(
      "[TAC Files] ⬆️ Subiendo portada..."
    );


    savedFile =
      await tacDraftUploadFreshFile(
        session,
        file,
        "cover",
        1
      );

  }


  const remote =
    tacDraftNormalizeRemoteFile(
      savedFile,
      file.name
    );


  console.log(
    "[TAC Files] ✅ Portada verified:",
    remote.id
  );


  return remote;

}

/* ==========================================================
   GENERIC PHOTO SLOT
   Sirve para estampas, fondos, rompecabezas, etc.
   ========================================================== */

async function tacDraftPersistPhotoSlot(
  {
    session,
    file,
    category,
    position,
    currentFile = null
  }
) {

  if (
    !(file instanceof File)
  ) {

    throw new Error(
      "invalid_photo_file"
    );

  }


  let savedFile;


  /*
    SLOT YA VERIFICADO:
    hacemos replacement seguro.
  */

  if (
    currentFile?.id &&
    currentFile.status ===
      "verified"
  ) {

    savedFile =
      await tacDraftReplaceFile(
        session,
        currentFile,
        file
      );

  }


  /*
    SLOT VACÍO O RESERVA INCOMPLETA.
  */

  else {

    if (
      currentFile?.id
    ) {

      await tacDraftDeleteFile(
        session,
        currentFile.id
      );

    }


    savedFile =
      await tacDraftUploadFreshFile(
        session,
        file,
        category,
        position
      );

  }


  return tacDraftNormalizeRemoteFile(
    savedFile,
    file.name
  );

}


/* ==========================================================
   MULTI UPLOAD POOL
   Concurrencia máxima configurable.
   ========================================================== */

async function tacDraftUploadPhotoBatch(
  {
    tasks,
    category,
    concurrency = 3,
    onUpdate = null
  }
) {

  const session =
    await tacEnsureDraftSession();


  const serverFiles =
    await tacDraftListFiles(
      session
    );


  /*
    Mapa del estado real que existe
    actualmente en D1/R2.
  */

  const existingByPosition =
    new Map();


  serverFiles
    .filter(
      item =>
        item.category ===
        category
    )
    .forEach(
      item => {

        existingByPosition.set(
          Number(
            item.position
          ),
          item
        );

      }
    );


  const queue =
    tasks.map(
      task => ({
        ...task,

        status:
          "queued",

        remote:
          null,

        error:
          null
      })
    );


  let cursor =
    0;


  const worker =
    async () => {

      while (
        true
      ) {

        const taskIndex =
          cursor++;


        if (
          taskIndex >=
          queue.length
        ) {

          return;

        }


        const task =
          queue[
            taskIndex
          ];


        task.status =
          "uploading";


        if (
          typeof onUpdate ===
            "function"
        ) {

          onUpdate(
            task
          );

        }


        try {

          const currentFile =
            existingByPosition.get(
              Number(
                task.position
              )
            ) || null;


          const remote =
            await tacDraftPersistPhotoSlot({
              session,
              file:
                task.file,
              category,
              position:
                task.position,
              currentFile
            });


          task.remote =
            remote;


          task.status =
            "verified";


          existingByPosition.set(
            Number(
              task.position
            ),
            remote
          );


          console.log(
            "[TAC Files] ✅",
            category,
            "posición",
            task.position,
            "verified"
          );


        } catch (
          error
        ) {

          task.status =
            "failed";


          task.error =
            String(
              error?.message ||
              error
            );


          console.error(
            "[TAC Files] ❌",
            category,
            "posición",
            task.position,
            error
          );

        }


        if (
          typeof onUpdate ===
            "function"
        ) {

          onUpdate(
            task
          );

        }

      }

    };


  const workerCount =
    Math.min(
      Math.max(
        1,
        Number(
          concurrency
        ) || 1
      ),
      queue.length
    );


  await Promise.all(
    Array.from(
      {
        length:
          workerCount
      },
      () =>
        worker()
    )
  );


  return queue;

}

tacDraftBindAutosaveEvents();
